import { styled } from "styled-components";

export const HomeContainer = styled('div')`
  height: 100%;
`

export const TagTitleP = styled("p")`
  color: ${({ theme }) => theme.colors.textColor} !important;
`;

export const TagContainerStyle = styled("div")`
  height: 100%;

  p, button, span {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .filter-tags {
    color: ${({ theme }) => theme.colors.textColorAccent};
  }

  .card:hover {
    box-shadow: 2px 2px 4.2px hsl(0deg 0% 0% / 0.17);
  }

  .card {
    border-radius: 6px;
  }

  .filtered-results-list-item:hover {
    box-shadow: ${({ theme }) => theme.shadows.boxShadow};
  }

  .card-header {
    background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.dashboardCardBg : theme.colors.selectGrey};
    box-shadow: 0.5px 1.5px 1.5px hsl(0deg 0% 0% / 0.17);

    h3, button { 
      color: ${({ theme }) => theme.colors.textColor} !important;
    }
  }

  .card-body {
    background-color: ${({ theme }) =>
      theme.name === "dark-theme" ? "rgba(85, 85, 85, .2)" : ""};
  }

  .MuiPaper-root {
    border: none !important;
  }

  .card-footer {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 0em 1em !important;
    border-top: none;
    background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.dashboardCardBg : theme.colors.selectGrey};
    button {
      color: ${({ theme }) =>
        theme.name === "dark-theme" ? `${theme.colors.textColor} !important` : "#1D1823"};
    }
  }

  .card-list {
    background-color: ${({ theme }) =>
      theme.name === "dark-theme" ? "rgba(85, 85, 85, .2)" : ""};

    p, h3, button, span {
      color: ${({ theme }) => theme.colors.textColor} !important;
    }
  }

  .filter-tag {
    box-shadow: ${({theme}) => theme.shadows.boxShadow};
    padding: 0.5rem 1rem;
    border-radius: 51px !important;
    background: ${({theme}) => theme.colors.buttonchipcolor} !important;
    color: ${({theme}) => theme.colors.textColor} !important;
  }

  .filter-tag:hover {
    color: ${({theme}) => theme.name === "light-theme" && theme.colors.white} !important;
    background-color: ${({theme}) => theme.name === "light-theme" && "#A100FF !important"};
  }
`;


export const TagAvailableNowLayoutButtons = styled("div")<{viewmode: string}>`
  button[data-active="true"] {
    background-color: ${({ theme }) => theme.colors.dashboardCardBg};
  }

  button {
    color: ${({theme}) => theme.colors.white};
  }
`;

export const TagAvailableNowCheckbox = styled("div")`
  position: relative;
  background: ${({ theme }) => theme.colors.tableBackground};
  padding: 0 1rem;
  border-radius: 8px;

  p {
    color: ${({theme}) => theme.colors.textColor} !important;
  }

  background-color: ${({ theme }) => theme.colors.dashboardCardBg} !important;

  .form-check {
    display: flex;
    align-items: baseline;
    position: relative;

    input {
      position: static;
      translate: 0px 2px;
    }

    label {
      background-color: transparent;
      margin: 0;
      padding-left: 0 !important;
    }
  }
`;

export const TagButtonsContainer = styled("div")`
  button:hover, button:active {
    background: #A100FF !important;
    color: ${({ theme }) => theme.name === "light-theme" ? `${theme.colors.textOpposite} !important` : `${theme.colors.white} !important`};
  }
`
export const TagButton = styled("button")<{ isselected: string }>`
  background: ${({ theme, isselected }) => (isselected === "true" ? `${theme.colors.dashboardSelectedCardsBg} !important` : "inherit")};
  color: ${({ theme, isselected }) => (isselected === "true" ? `${theme.colors.white} !important` : theme.colors.textColor)};
`;